export default __webpack_public_path__ + "static/catalogue-search-3d-filter-buyer-view-64f75426693bfe4053805ebe3a237840.png";